export interface FAQ {
  id: number;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 1,
    question: '如何在高清视频在线观看平台观看视频？',
    answer: '您只需访问我们的网站，通过首页或分类页面浏览感兴趣的高清视频内容，点击视频卡片即可进入播放页面。所有高清视频在线观看无需下载任何软件，直接在浏览器中流畅播放。我们支持电脑、平板和手机等多种设备访问。',
  },
  {
    id: 2,
    question: '高清视频在线观看需要注册账号吗？',
    answer: '观看高清视频内容无需注册账号，所有用户均可免费在线观看。注册账号后您可以享受更多功能，包括收藏喜爱的超清视频、订阅频道更新通知、参与社区讨论等个性化服务。',
  },
  {
    id: 3,
    question: '为什么有些超清视频在线观看时会出现卡顿？',
    answer: '超清视频在线观看的流畅度主要取决于您的网络带宽和设备性能。建议您：1. 确保网络连接稳定，推荐使用10Mbps以上带宽；2. 关闭其他占用带宽的应用程序；3. 如遇卡顿可尝试切换至高清画质；4. 清理浏览器缓存后重试。我们持续优化CDN分发网络以提供更好的高清影视在线体验。',
  },
  {
    id: 4,
    question: '平台上的国产高清视频内容多久更新一次？',
    answer: '我们的高清视频内容每日更新，涵盖电影、电视剧、综艺、动漫、纪录片等多个品类。热门国产高清视频通常在首播后24小时内上线。您可以通过订阅更新提醒，第一时间获取最新高清视频在线观看通知。',
  },
  {
    id: 5,
    question: '高清影视在线支持哪些播放设备？',
    answer: '高清影视在线观看全面支持各类设备：Windows/Mac电脑端通过主流浏览器访问；iOS/Android移动端通过手机浏览器访问；智能电视和投影仪可通过投屏功能享受大屏超清视频在线观看体验。所有设备均自动适配最佳画质。',
  },
  {
    id: 6,
    question: '如何搜索我想看的高清视频在线内容？',
    answer: '您可以使用网站顶部的搜索功能，输入关键词（如影片名称、导演、演员等）即可快速找到相关的高清视频内容。同时，您也可以按分类浏览，通过电影、电视剧、综艺、动漫等类别筛选感兴趣的国产高清视频。',
  },
  {
    id: 7,
    question: '高清视频在线播放的画质可以选择吗？',
    answer: '是的，在视频播放页面您可以根据需要选择不同的画质选项，包括流畅、高清、超清等。系统默认根据您的网络状况自动匹配最佳画质，确保超清视频在线观看不卡顿的同时兼顾最佳视觉效果。',
  },
  {
    id: 8,
    question: '平台上的超清视频在线观看是否收费？',
    answer: '平台大部分高清视频内容均可免费在线观看。部分最新院线大片和独家内容可能需要会员权限。我们始终致力于为用户提供丰富的高清影视在线资源，让更多人享受高清视频在线播放的乐趣。',
  },
];